import { useContext, useEffect, useState } from 'react';
import ReactModal from 'react-modal';
import { IoIosClose } from 'react-icons/io';

import { ModalContext } from 'context/ModalContext';

export function PontosHelpModal(props: any) {
  // const modalID = "achievement";

  const modalID = 'help-pontos';

  const [modalIsOpen, setIsOpen] = useState(false);

  const { openModal, closeModal } = useContext(ModalContext);

  ReactModal.setAppElement('#modal');

  function handleCloseModal() {
    //
  }

  function afterOpenModal() {
    //
  }

  useEffect(() => {
    setIsOpen(openModal === modalID);
  }, [openModal]);

  return (
    <>
      <ReactModal
        shouldCloseOnOverlayClick={false}
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={handleCloseModal}
        contentLabel="Minhas Estrelas"
        portalClassName="relative z-50"
        overlayClassName="rb-modal-overlay"
        contentElement={() => (
          <div className="rb-modal rb-modal--md">
            <button className="rb-modal__close" aria-label="Fechar" onClick={() => closeModal()}>
              <IoIosClose size={26} />
            </button>

            <div className="rb-modal__header">
              <h1 className="rb-modal__title">Minhas Estrelas</h1>
            </div>

            <p className="rb-modal__text">
              Este é o total de estrelas que você acumulou como resultado dos reconhecimentos recebidos dos seus colegas, das suas
              entregas e de outras atividades no Reconheça BRB.
            </p>

            <div className="rb-modal__actions">
              <button className="rb-btn-primary" onClick={() => closeModal()}>
                Fechar
              </button>
            </div>
          </div>
        )}
      />
    </>
  );
}
